import styled from "styled-components";
import React from 'react';

const LoadingSpinner = styled.div`
  background: none;
  position: relative;
  width: 200px;
  height: 200px;
  margin: auto;
  div {
    position: absolute;
    display: block;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 80px;
    box-shadow: 0 6px 0 0 #00C3CB;
    -ms-animation: uil-ring-anim 1s linear infinite;
    -moz-animation: uil-ring-anim 1s linear infinite;
    -webkit-animation: uil-ring-anim 1s linear infinite;
    -o-animation: uil-ring-anim 1s linear infinite;
    animation: uil-ring-anim 1s linear infinite;
  }

  &.loading-symbol {
    opacity: 1;
    transform: scale(0.6);

    &.loading {
      -webkit-animation: loading-opacity 1s linear;
      -ms-animation: loading-opacity 1s linear;
      -moz-animation: loading-opacity 1s linear;
      -o-animation: loading-opacity 1s linear;
      animation: loading-opacity 1s linear;
    }
  }

  @keyframes uil-ring-anim {
    0% {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes loading-opacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const LoadingSpinnerWrapper = (props) => {
  return props.condition
    ? (<LoadingSpinner><div /></LoadingSpinner>)
    : props.children;
}

export default LoadingSpinner;
